import Vue from "vue";
import { LocaleMessage } from "vue-i18n";

export function notifySuccessMessage(text: LocaleMessage) {
  Vue.notify({
    type: "success",
    title: "SUCCESS",
    text: String(text),
    duration: 3000,
    speed: 1000,
  });
}

export function notifyWarningMessage(text: LocaleMessage) {
  Vue.notify({
    type: "warn",
    title: "WARNING",
    text: String(text),
    duration: 3000,
    speed: 1000,
  });
}

export function notifyErrorMessage(text: LocaleMessage) {
  Vue.notify({
    type: "error",
    title: "ERROR",
    text: String(text),
    duration: 3000,
    speed: 1000,
  });
}
